import { ChangeDetectionStrategy, Component, Injectable } from '@angular/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import moment from 'moment';

import { DatepickerPanelDirective } from './datepicker-panel.directive';
import { FormFieldControl } from '../form-field/form-field-control';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor() {
    // NOTE: The locale is hardcoded to 'de'. To change it, use translocoService.getActiveLang().
    super('de');
  }

  public getFirstDayOfWeek(): number {
    return 1;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getDayOfWeekNames(_: 'long' | 'short' | 'narrow'): string[] {
    const formatter = new Intl.DateTimeFormat(this.locale, { weekday: 'short' });
    return Array.from({ length: 7 }, (_, i) => formatter.format(new Date(1970, 0, 4 + i)));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public format(date: Date, _: string): string {
    return Intl.DateTimeFormat(this.locale).format(date);
  }

  public createDate(year: number, month: number, date: number): Date {
    return moment.utc([year, month, date]).toDate();
  }
}

@Component({
  selector: 'tt-datepicker',
  standalone: true,
  template: '',
  exportAs: 'ttDatepicker',
  providers: [
    {
      provide: FormFieldControl,
      useExisting: DatepickerComponent,
    },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatepickerComponent extends DatepickerPanelDirective {}
